export default "__VITE_ASSET__Cs9tDm_t__"